// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"06cd6fb1","41":"1670b893","631":"9f257396","653":"a372199c","731":"610a2810","742":"ecbfb104","945":"6bbc7578","975":"d34a1216"}[chunkId] + ".chunk.js";
};